import { Vector2 } from "@babylonjs/core/Maths/math.vector";
import { AbstractRoomTool } from "./tools";
import { InteractionMode } from "@egr/wcf/modules/core/tool";
import { eq } from "@egr/wcf/modules/utils/math";
export class AbstractInteractorTool extends AbstractRoomTool {
    constructor(pRoomManager, pPickPlanePos) {
        super(pRoomManager, pPickPlanePos);
        this.mRoomManager = pRoomManager;
        this.mMouseMoved = false;
    }
    start(pParameter) {
        this.mView = this.mRoomManager.view;
        this.setInteractionMode(InteractionMode.Primary);
        this.prepareSnapping();
        this.prepareFeedback();
        return (super.start(pParameter));
    }
    stop() {
        super.stop();
        this.clearFeedback();
    }
    handlePointerDown(pEvent, pState) {
        let tPointer = pState.pointers.get(pEvent.pointerId);
        if (tPointer == null)
            return;
        let tPos = this.getPlanePickPos2d(tPointer.position);
        if (tPos != null) {
            this.startPos(tPos);
        }
    }
    handlePointerUp(pEvent, pState) {
        if (!this.mMouseMoved) {
            this.mRoomManager.eventInteractorMouseUpWOmove.trigger(this.mRoomManager);
        }
        if (!pState.isPrimaryPointer(pEvent))
            return;
        let tPointer = pState.pointers.get(pEvent.pointerId);
        if (tPointer == null)
            return;
        let tDist = Vector2.Distance(tPointer.initialPosition, tPointer.position);
        if (eq(tDist, 0))
            this.stop();
        else
            this.finish();
    }
    handlePointerMove(pEvent, pState) {
        this.mMouseMoved = true;
        if (!pState.isPrimaryPointer(pEvent))
            return;
        let tPointer = pState.pointers.get(pEvent.pointerId);
        if (tPointer == null)
            return;
        let tPos = this.getPlanePickPos2d(tPointer.position);
        if (tPos != null) {
            this.updatePointerPosition(tPos, tPointer.position);
            this.validate();
            this.updateFeedback();
        }
    }
    prepareFeedback() {
        //
    }
    clearFeedback() {
        //
    }
    updateFeedback() {
        //
    }
    prepareSnapping() {
        this.mSnapAxes = new Array();
        this.mSnapPoints = new Array();
    }
    finish() {
        this.stop();
    }
    validate() {
        //
    }
}
